import {
  Component,
  OnInit,
  Inject,
  ChangeDetectionStrategy
} from '@angular/core';
import { DialogRef, DIALOG_DATA } from '@apps/ui';
import { Destroyer } from '@apps/tools';

export interface DialogError {
  reason: string;
  status: number;
}

@Component({
  selector: 'sc-dialog-error',
  templateUrl: './dialog-error.component.html',
  styleUrls: ['./dialog-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogErrorComponent extends Destroyer implements OnInit {
  constructor(
    public dialogRef: DialogRef<DialogErrorComponent>,
    @Inject(DIALOG_DATA) public data: DialogError
  ) {
    super();
  }

  ngOnInit() {}

  close(): void {
    this.dialogRef.close();
  }
}
